import { inject } from '@angular/core';
import type { FactoryEdit } from '@indutrust/factory-model';
import { withCrudSingleEvents } from '@indutrust/shared-util';
import { signalStore, withMethods } from '@ngrx/signals';
import type { EntityId } from '@ngrx/signals/entities';
import { FactoryApiClient } from './factory-api-client.service';
import { factorySingleEvents } from './factory-single.events';

/**
 * Signal store providing CRUD operations for a single {@link FactoryEdit} entity.
 *
 * Pattern C (single-entity CRUD). Wires `loadById`, `edit` and `delete`
 * against {@link FactoryApiClient}.
 *
 * @example
 * const store = inject(FactoryStore);
 * store.loadById(1);
 */
export const FactoryStore = signalStore(
  withCrudSingleEvents(factorySingleEvents, () => inject(FactoryApiClient)),
  withMethods((store) => ({
    /**
     * Partially updates a factory entity.
     *
     * @param id - The {@link EntityId} of the factory to patch.
     * @param update - Partial {@link FactoryEdit} payload.
     * @example
     * factoryStore.patch(7, { name: 'Updated' });
     */
    patch(id: EntityId, update: Partial<FactoryEdit>): void {
      store.edit(id, update);
    },
  }))
);
